<template>
    <v-menu transition="slide-y-transition"
            right
            bottom>
        <template v-slot:activator="{ on }">
            <v-btn class="tab-menu__button"
                   small
                   fab
                   dark
                   v-on="on"
                   transition="scroll-y-transition"
                   color="transparent">
                <v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
        </template>
        <v-list class="list__menu">
            <v-list-item class="list__menu-item">
                <v-list-item-title class="list__menu-text">
                    <v-icon>mdi-dots-horizontal</v-icon>
                </v-list-item-title>
            </v-list-item>
            <v-list-item v-ripple @click="deleteAnalysis($event)" class="list__menu-item">
                <v-list-item-title class="list__menu-text">
                    <v-img :src="require('@/assets/img/icons/trash.svg')"></v-img>
                    <span>Delete</span>
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
    export default {
        name: "TabOverviewTabMenu",
        methods: {
            deleteAnalysis: function (e) {
                console.log('deleteAnalysisClick', e)
                this.$emit('deleteAnalysisClick')
            }
        }
    }
</script>

<style scoped>

</style>
